module.exports = __webpack_public_path__ + "img/content_bg.ecc7c576.png";